(() => {
  'use strict';

  function initialise(scope = document) {
    scope.querySelectorAll('[data-collection-form]').forEach((form) => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      form.querySelector('[data-collection-sort]')?.addEventListener('change', () => form.requestSubmit());
    });
    scope.querySelectorAll('[data-site-header]').forEach((header) => {
      if (header.dataset.ready) return;
      header.dataset.ready = 'true';
      const toggle = header.querySelector('[data-menu-toggle]');
      const nav = header.querySelector('[data-site-nav]');
      if (!toggle || !nav) return;
      const close = () => {
        toggle.setAttribute('aria-expanded', 'false');
        nav.classList.remove('is-open');
      };
      toggle.addEventListener('click', () => {
        const open = toggle.getAttribute('aria-expanded') !== 'true';
        toggle.setAttribute('aria-expanded', String(open));
        nav.classList.toggle('is-open', open);
      });
      nav.addEventListener('click', (event) => {
        if (event.target.closest('a')) close();
      });
      header.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
          close();
          toggle.focus();
        }
      });
    });

    scope.querySelectorAll('[data-product-section]').forEach((section) => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const image = section.querySelector('.product-primary-image');
      const thumbnails = section.querySelectorAll('[data-gallery-image]');
      thumbnails.forEach((thumbnail) => thumbnail.addEventListener('click', () => {
        if (!image) return;
        image.src = thumbnail.dataset.galleryImage;
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.alt = thumbnail.dataset.galleryAlt || '';
        thumbnails.forEach((item) => {
          const active = item === thumbnail;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-pressed', String(active));
        });
      }));
      const variants = section.querySelector('[data-variant-select]');
      const button = section.querySelector('[data-add-button]');
      const price = section.querySelector('[data-product-price]');
      if (variants) variants.addEventListener('change', () => {
        const option = variants.selectedOptions[0];
        if (!option) return;
        if (price) price.textContent = option.dataset.price || '';
        if (button) {
          const available = option.dataset.available === 'true';
          button.disabled = !available;
          button.textContent = available ? button.dataset.availableLabel : button.dataset.unavailableLabel;
        }
        if (image && option.dataset.image) {
          image.src = option.dataset.image;
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          image.alt = option.dataset.imageAlt || '';
          thumbnails.forEach((thumbnail) => {
            const active = thumbnail.dataset.galleryImage === option.dataset.image;
            thumbnail.classList.toggle('is-active', active);
            thumbnail.setAttribute('aria-pressed', String(active));
          });
        }
      });
    });
  }

  initialise();
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();

/* Arrow-key navigation for product-image thumbnails. */
document.addEventListener('keydown',function(event){
 const current=event.target.closest('[data-gallery-image]');
 if(!current||!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
 const gallery=current.closest('.product-thumbnails');
 if(!gallery)return;
 const buttons=Array.from(gallery.querySelectorAll('[data-gallery-image]'));
 const at=buttons.indexOf(current);let next=at;
 if(event.key==='Home')next=0;
 else if(event.key==='End')next=buttons.length-1;
 else next=(at+(event.key==='ArrowRight'?1:-1)+buttons.length)%buttons.length;
 event.preventDefault();buttons[next].focus();buttons[next].click();
});
